const meta = (
  import.meta as unknown as { env: Record<string, string | undefined> }
).env;

export const API_BASE_URL = meta.VITE_API_BASE_URL ?? "http://localhost:4000";
export const WEB_APEX_URL = meta.VITE_WEB_APEX_URL ?? "http://localhost:3000";
export const APP_URL = meta.VITE_APP_URL ?? "http://localhost:3002";
